import { render, staticRenderFns } from "./UserCreateView.vue?vue&type=template&id=3dc6fc2a&"
import script from "./UserCreateView.vue?vue&type=script&lang=ts&"
export * from "./UserCreateView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports